import { Children, type FC, type ReactNode } from "react";

import styles from "./ServicesGrid.module.scss";

interface ServicesGridProps {
  children: ReactNode;
}

export const ServicesGrid: FC<ServicesGridProps> = ({ children }) => {
  const childrenArray = Children.toArray(children);
  const count = childrenArray.length;

  return (
    <div className={styles.container}>
      <div className={`${styles.grid} ${styles[`items-${count}`]}`}>{children}</div>
    </div>
  );
};
